// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"c446c2fb","856":"2d674356"}[chunkId] + ".js";
};